import { render, staticRenderFns } from "./myDistribution_1_detail.vue?vue&type=template&id=03245124"
import script from "./myDistribution_1_detail.vue?vue&type=script&lang=js"
export * from "./myDistribution_1_detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports